'use strict';

module.exports = require('./Autowhatever').default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-autowhatever/dist/index.js
 ** module id = 1439
 ** module chunks = 0
 **/